// extracted by mini-css-extract-plugin
module.exports = {"glacierWaveTreaserB":"B_glacierWaveTreaserB__tPNNS"};